import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { initAnalytics } from './analytics';

// A pre-rendered page (scripts/prerender.js) ships its head tags for crawlers
// that don't run JavaScript. The app renders them again, so drop the static
// copies first; otherwise every page would carry two canonicals and titles.
document.querySelectorAll('[data-prerendered]').forEach((el) => el.remove());

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
